import { useState, useEffect } from 'react';

/** Reactive `window.matchMedia` (remplace `useMediaQuery` de MUI). */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};

// Mêmes seuils que les breakpoints Tailwind/MUI du projet (sm = 600px).
/** Téléphone : `< sm` (< 600px), comme `theme.breakpoints.down('sm')` de MUI. */
export const useIsMobile = (): boolean => useMediaQuery('(max-width: 599.95px)');
/** Poste fixe : `>= sm`. */
export const useIsDesktop = (): boolean => useMediaQuery('(min-width: 600px)');
